export default "__VITE_ASSET__CYY3_oPw__"